<div fxLayout="column" class="container">
  <div fxLayout="row" fxLayoutGap="8px" *ngFor="let yarnType of yarnTypes" fxLayoutAlign="end">
    <span #name class="yarn-type-yarn-consumption test" [matTooltipDisabled]="!showTooltip" [matTooltip]="getYarnConsumptionCommercialLengthInMeters(yarnType)">{{
      getYarnConsumptionCommercialLengthInMeters(yarnType)
    }}</span>
    <span class="weight">({{ yarnType.yarnConsumption.weightInKilogramPerSquareMeter | number }}kg/m²)</span>
  </div>
</div>
